<template>
<div class="modal fade" id="loginVerifyModal" tabindex="-1" aria-labelledby="loginVerifyModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title" id="loginVerifyModalLabel">Acceso de Usuario</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
              <form class="login-form">
                  <div class="form-group">
                      <label for="username"><i class="fas fa-user"></i> Usuario:</label>
                      <input type="password" v-model="username" class="form-control" required>
                  </div>
                  <div class="form-group">
                      <label for="password"><i class="fas fa-lock"></i> Contraseña:</label>
                      <input type="password" v-model="password" class="form-control" required>
                  </div>
                  <button @click="handleSubmit()" class="btn btn-primary w-100">Entrar</button>
              </form>
          </div>
      </div>
  </div>
</div>
</template>
<script>
export default {
  data() {
    return {
      username: '',
      password: ''
    };
  },
  methods: {
    handleSubmit() {
      // Emitir los datos de usuario y contraseña al componente padre
      this.$emit('login', {
        username: this.username,
        password: this.password
      });
      $("#loginVerifyModal").modal("hide");
      // Limpiar los campos del formulario (opcional)
      this.username = '';
      this.password = '';
    }
  }
};
</script>